import { useBillingStore, type PlanFeatures } from '@/stores/billingStore';
import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ProGateProps {
  feature?: keyof PlanFeatures;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function ProGate({ feature, children, fallback }: ProGateProps) {
  const plan = useBillingStore((s) => s.plan);
  const features = useBillingStore((s) => s.features);
  const navigate = useNavigate();

  const hasAccess = feature ? features[feature] : plan === 'pro';

  if (hasAccess) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-xl border border-border bg-card p-8 text-center">
      <div className="rounded-full bg-primary/10 p-3">
        <Lock className="h-6 w-6 text-primary" />
      </div>
      <div>
        <h3 className="text-lg font-semibold text-foreground">Pro Feature</h3>
        <p className="mt-1 text-sm text-muted-foreground">
          Upgrade to Pro to unlock this feature.
        </p>
      </div>
      <button
        onClick={() => navigate('/settings?tab=billing')}
        className="rounded-lg bg-primary px-5 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
      >
        Upgrade to Pro
      </button>
    </div>
  );
}
